/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  flagged Ids index
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { default as rootReducer } from './reducers/index'

export default filterActions(rootReducer, Object.values(constants))
